type SaveDayWarning = {
  name?: string | null;
  description?: string | null;
};

/**
 * The one message a saved day's warnings are shown as, or null when there are none.
 *
 * They arrive as a list — a month-break week that also duplicates hours raises
 * two at once — but node-snackbar keeps a single element and replaces its
 * contents, so issuing them one by one would leave only the last one on screen.
 *
 * The separator is markup because that element is written with `innerHTML`
 * (`node-snackbar/dist/snackbar.js`), which is also why a newline would collapse
 * to a space here.
 */
export function saveDayWarningMessage(
  warnings: SaveDayWarning[] | null | undefined
): string | null {
  const messages = (warnings ?? [])
    .map((warning) => warning?.description || warning?.name || "")
    .filter((text) => text.length > 0);

  return messages.length > 0 ? messages.join("<br><br>") : null;
}
